import { TestPlanService } from '@/api/testPlan';
import { Loading } from '@/components/Loading';
import { Section } from '@/components/Section';
import { OutlineButton } from '@/components/shared/button/OutlineButton';
import { useBackNavigate } from '@/utils/hooks/useBackNavigate';
import React from 'react';
import { useParams } from 'react-router-dom';
import { CardDetail } from '@/components/shared/card/CardDetail';

const formatDate = (dateString?: string) =>
  dateString ? new Date(dateString).toISOString().split('T')[0] : undefined;

export const DetailTestPlan: React.FC = () => {
  const { testPlanId } = useParams();
  const backNavigate = useBackNavigate();

  const { data, isFetching: isFetchLoading } =
    TestPlanService.useGet(testPlanId);

  return (
    <Section title={data?.code}>
      {isFetchLoading ? (
        <Loading />
      ) : (
        <div>
          <div className="flex flex-row gap-10">
            <div className="flex flex-col w-full gap-3">
              <CardDetail title="Test Plan Name" value={data?.plan_name} />

              <CardDetail title="Description" value={data?.description} />
            </div>

            <div className="flex flex-col w-full gap-3 ">
              <CardDetail
                title="Assignment Time"
                value={formatDate(data?.assignment_time)}
              />

              <CardDetail
                title="Expiration Time"
                value={formatDate(data?.expiration_time)}
              />
            </div>
          </div>
          <div className="mt-5">
            <OutlineButton onClick={backNavigate}>Back</OutlineButton>
          </div>
        </div>
      )}
    </Section>
  );
};
